/**
 * TabDiagnostyka — Zakładka "Diagnostyka" — pełna diagnostyka KSeF w 4 stages.
 *
 * Refaktor 2026-06-01 (Opcja A): zastąpiono 3 osobne panele (CertKeyPairTest,
 * HealthCheckButton, MtlsTestPanel) jednym kompleksowym <FullDiagnosticsPanel>.
 * Wyniki kopiowalne (markdown) + JSON download. Stages: lokalna konfig →
 * walidacja pary → mTLS handshake → pełen auth flow.
 *
 * Props:
 *   - onTested (callback)
 */
import { Shield } from "lucide-react";
import { FullDiagnosticsPanel } from "../components/FullDiagnosticsPanel";

export const TabDiagnostyka = ({ onTested }) => {
  return (
    <div className="space-y-4" data-testid="tab-diagnostyka">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Shield className="w-4 h-4 text-gray-500" />
          <h3 className="text-sm font-semibold text-gray-700">Diagnostyka połączenia z KSeF</h3>
        </div>
        <p className="text-xs text-gray-500">
          Kompleksowy test — od konfiguracji lokalnej po pełen auth flow z KSeF API.
          Wynik zawiera szczegóły każdego stage'a i można go skopiować (do supportu) lub pobrać jako JSON.
        </p>
      </div>

      <FullDiagnosticsPanel onTested={onTested} />
    </div>
  );
};

export default TabDiagnostyka;
